import _ from 'lodash';
import { sanitizePII } from '@wix/bi-logger-sanitizer';
const sanitizeEvent = event => _.mapValues(event, sanitizePII);
export const loggerFactory = (biFactory, mutator = x => x) => {
    const logger = biFactory.logger();
    return _.flow(mutator, sanitizeEvent, logger.log.bind(logger));
};
export const BI_DASHBOARD_ENDPOINT = 'expert-dashboard';
export const BI_FEEDBACK_ENDPOINT = 'get-feedback';
export const BI_ARENA_ENDPOINT = 'marketplace';
export const BI_LOYALTY_ENDPOINT = 'loyalty-program';
export const BI_SOURCE = 80;
//# sourceMappingURL=bi.js.map